import { Box, Modal, Typography } from "@mui/material";
import { IModalFailureTypesSettings } from "./AddFailureTypesModalInterfaces";
import { useStyles, modalStyles } from "./AddFailureTypesModal.styles";

export const AddFailureTypesModal = ({ open, handleClose, title, children }: IModalFailureTypesSettings) => {
    const classes = useStyles();
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={modalStyles}>
                <Typography className={classes.modalTitle}>{title}</Typography>
                <Box className={classes.bodyContainer}>{children}</Box>
            </Box>
        </Modal>
    );
};
